import React from "react";

import { Badge } from "@/components/flowbite/badge/badge";
import { cn } from "@/shared/helpers/cn.helper";

interface SectionBadgesProps {
  items: string[];
  bordered?: boolean;
}

export const SectionBadges: React.FC<SectionBadgesProps> = ({ items, bordered = false }) => {
  return (
    <div
      className={cn(
        "mt-2 flex flex-wrap gap-2 py-3",
        bordered && "border-b border-gray-200",
      )}
    >
      {items.map((item) => (
        <Badge key={item}>{item}</Badge>
      ))}
    </div>
  );
};